"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _lodash = require("lodash");
var _FinproProfileUtility = require("./FinproProfileUtility");
var _titleHeadTag = require("../../lib/titleHeadTag");
var _imageSrc = require("../../lib/imageSrc");
var _CalendlyModal = _interopRequireDefault(require("./CalendlyModal"));
var _CTAButton = _interopRequireDefault(require("../CTAButton"));
var _constants = require("../../utils/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 *  A react component to list finpro agents
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.agents agents list to display
 * @param {object} props.managigAgents managing agents display, only applicable for agency page
 * @param {object} props.featuredAgents featured agents display, only applicable for agency page
 * @param {object} props.coreAgencyNumber core agency id
 * @param {object} props.subAgencyNumber satellitle office id
 * @param {object} props.onLeadModelShow function on call to open lead modal
 *
 * @returns {React.ReactElement} list of agents
 */
function ListAgents(props) {
  // Calendly Modal event
  var [showCalendlyModal, setShowCalendlyModal] = (0, _react.useState)(false);
  var [calendlyLink, setCalendlyLink] = (0, _react.useState)('');
  var handleCalendlyModalShow = calendlyLink => {
    if (!((0, _lodash.isEmpty)(calendlyLink) || (0, _lodash.isNil)(calendlyLink))) {
      setShowCalendlyModal(true);
      setCalendlyLink(calendlyLink);
    }
  };
  var handleCalendlyModalClose = () => {
    setShowCalendlyModal(false);
    setCalendlyLink('');
  };
  var GetCalendly = props => {
    if ((0, _lodash.isEmpty)(props.calendlyLink) || (0, _lodash.isNil)(props.calendlyLink)) return null;else {
      return /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
        buttonType: 'secondary',
        label: 'Schedule an Appointment',
        dataId: (0, _FinproProfileUtility.GetCTADataId)(_constants.CALENDLY_CTA_LABEL, props.agentUrl),
        onClick: () => handleCalendlyModalShow(props.calendlyLink),
        icon: 'icon-external-link',
        iconDirection: 'right'
      });
    }
  };
  var GetLeadFormLink = agent => {
    if (agent.showForm) {
      var label = "Connect with ".concat(agent.firstName);
      var formProps = {
        coreAgencyNumber: props.coreAgencyNumber,
        subAgencyNumber: props.subAgencyNumber,
        agentId: agent.agentId,
        agencyName: props.agencyName,
        modalTitle: label
      };
      return /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
        buttonType: 'inline',
        label: label,
        dataId: (0, _FinproProfileUtility.GetCTADataId)(_constants.LEADS_CTA_LABEL, agent.agentUrl),
        icon: 'icon-ask',
        iconDirection: 'left',
        onClick: () => props.onLeadModelShow(formProps)
      });
    } else return null;
  };
  var GetAgentSpecializedContent = props => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-media-object"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "body"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("strong", null, "Languages: "), /*#__PURE__*/_react.default.createElement("span", null, props.languages.join(', '), " ")), props.specialties && props.specialties.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "link-padding"
    }, /*#__PURE__*/_react.default.createElement("strong", null, "Specialties: "), /*#__PURE__*/_react.default.createElement("span", null, props.specialties.join(', '), " "))));
  };
  var GetAgentPicture = props => {
    if ((0, _lodash.isEmpty)(props.profileImage)) return null;else {
      return /*#__PURE__*/_react.default.createElement("picture", {
        className: "mm-img-circle--xl"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: (0, _imageSrc.finproProfileImageHref)(props.profileImage),
        alt: "MassMutual financial professional."
      }));
    }
  };
  var GetFeaturedAgentsDetail = props => {
    var specializedAgentTitle = props.isGA ? 'Managing Partner' : 'Featured Financial Professional';
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      lg: 6,
      md: 7,
      sm: 12
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-media-object"
    }, /*#__PURE__*/_react.default.createElement(GetAgentPicture, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "body"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "eyebrow"
    }, specializedAgentTitle), (0, _titleHeadTag.headTagTitleWithAnchor)(props.fullName, 'title', 'h3', props.agentUrl, '_self', props.fullName, 'btn btn-inline'), props.isGA && !(0, _lodash.isEmpty)(props.agentTitle) && /*#__PURE__*/_react.default.createElement("span", {
      className: "eyebrow"
    }, props.agentTitle), !(0, _lodash.isEmpty)(props.workPhone) && /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetPhone, {
      value: props.workPhone
    }), !props.isGA && /*#__PURE__*/_react.default.createElement(GetLeadFormLink, {
      showForm: props.showLeadForm,
      agentId: props.agentId,
      firstName: props.firstName,
      agentUrl: props.agentUrl
    }), /*#__PURE__*/_react.default.createElement(GetCalendly, {
      calendlyLink: props.calendly,
      agentUrl: props.agentUrl
    })))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      lg: 6,
      md: 5,
      sm: 12
    }, /*#__PURE__*/_react.default.createElement(GetAgentSpecializedContent, props)));
  };
  var GetAgentsDetail = props => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      lg: 6,
      md: 7,
      sm: 12
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-media-object"
    }, /*#__PURE__*/_react.default.createElement(GetAgentPicture, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "body"
    }, (0, _titleHeadTag.headTagTitleWithAnchor)(props.fullName, undefined, 'h3', props.agentUrl, '', props.fullName, 'btn btn-inline'), !(0, _lodash.isEmpty)(props.workPhone) && /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetPhone, {
      value: props.workPhone
    }), /*#__PURE__*/_react.default.createElement(GetLeadFormLink, {
      showForm: props.showLeadForm,
      agentId: props.agentId,
      firstName: props.firstName,
      agentUrl: props.agentUrl
    }), /*#__PURE__*/_react.default.createElement(GetCalendly, {
      calendlyLink: props.calendly,
      agentUrl: props.agentUrl
    })))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      lg: 6,
      md: 5,
      sm: 12
    }, /*#__PURE__*/_react.default.createElement(GetAgentSpecializedContent, props)));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "finpro-agent-list"
  }, props.managingAgents && props.managingAgents.length > 0 && (0, _lodash.map)(props.managingAgents, (agent, agentIndex) => {
    return /*#__PURE__*/_react.default.createElement("section", {
      key: "ga-".concat(agentIndex)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "container"
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(GetFeaturedAgentsDetail, _extends({}, agent, {
      isGA: true
    })))), /*#__PURE__*/_react.default.createElement("hr", null));
  }), props.featuredAgents && props.featuredAgents.length > 0 && (0, _lodash.map)(props.featuredAgents, (agent, agentIndex) => {
    return /*#__PURE__*/_react.default.createElement("section", {
      key: "fa-".concat(agentIndex)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "container"
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(GetFeaturedAgentsDetail, _extends({}, agent, {
      isGA: false
    })))), /*#__PURE__*/_react.default.createElement("hr", null));
  }), (0, _lodash.map)(props.agents, (agent, agentIndex) => {
    return /*#__PURE__*/_react.default.createElement("section", {
      key: "agent-".concat(agentIndex)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "container"
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(GetAgentsDetail, agent))), /*#__PURE__*/_react.default.createElement("hr", null));
  }), /*#__PURE__*/_react.default.createElement(_CalendlyModal.default, {
    show: showCalendlyModal,
    navigateLink: calendlyLink,
    onModelClose: handleCalendlyModalClose
  }));
}
var _default = exports.default = ListAgents;